import Vue from 'vue'
import Router from 'vue-router'

import Dome from './router-child/dome'         // dome类
import User from './router-child/user'         // 用户类
import Operation from './router-child/operation'         // 用户类
import Article from './router-child/article'         // 用户类

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/login',
      name: 'Index',
      component: () =>
      import(/* webpackChunkName: "Index" */ '@/components/Index')
    },
    ...Dome,      // dome类
    ...Operation, // Operation
    ...Article, // 文章
    ...User       // 用户类
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js